// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"hEqeo":[function(require,module,exports) {
var _preview = require("./dist/preview");

},{"./dist/preview":"6MOiN"}],"6MOiN":[function(require,module,exports) {
var _global = require("@storybook/global");
var _previewApi = require("@storybook/preview-api");
var ADDON_ID = "storybook/a11y";
var RESULT = `${ADDON_ID}/result`, REQUEST = `${ADDON_ID}/request`, RUNNING = `${ADDON_ID}/running`, ERROR = `${ADDON_ID}/error`, MANUAL = `${ADDON_ID}/manual`, EVENTS = {
    RESULT,
    REQUEST,
    RUNNING,
    ERROR,
    MANUAL
};
var { document, window: globalWindow } = (0, _global.global), channel = (0, _previewApi.addons).getChannel(), active = !1, activeStoryId, handleRequest = async (storyId)=>{
    let { manual } = await getParams(storyId);
    manual || await run(storyId);
}, run = async (storyId)=>{
    activeStoryId = storyId;
    try {
        let input = await getParams(storyId);
        if (!active) {
            active = !0, channel.emit(EVENTS.RUNNING);
            let axe = (await require("89abf3a7c3a87096")).default || await require("89abf3a7c3a87096"), { element = "#storybook-root", config, options = {} } = input, htmlElement = document.querySelector(element);
            if (!htmlElement) return;
            axe.reset(), config && axe.configure(config);
            let result = await axe.run(htmlElement, options), resultJson = JSON.parse(JSON.stringify(result));
            activeStoryId === storyId ? channel.emit(EVENTS.RESULT, resultJson) : (active = !1, run(activeStoryId));
        }
    } catch (error) {
        channel.emit(EVENTS.ERROR, error);
    } finally{
        active = !1;
    }
}, getParams = async (storyId)=>{
    let { parameters } = await globalWindow.__STORYBOOK_STORY_STORE__.loadStory({
        storyId
    }) || {};
    return parameters.a11y || {
        config: {},
        options: {}
    };
};
channel.on(EVENTS.REQUEST, handleRequest);
channel.on(EVENTS.MANUAL, run);

},{"@storybook/global":"4g4co","@storybook/preview-api":"uDWyg","89abf3a7c3a87096":"koKWc"}],"koKWc":[function(require,module,exports) {
module.exports = require("645b7b3856f2d9b4")(require("83b31274131ba30b").resolve("i9dE9")).then(()=>module.bundle.root('d0iPb'));

},{"645b7b3856f2d9b4":"bvDWj","83b31274131ba30b":"kK08P"}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=preview.c5fb6e43.js.map
